import { UIText1, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ImageAsDocumentMessage.css';

type TImageAsDocumentMessageProps = {
  imageNode: React.ReactNode;
  name: string;
  size?: string;
  src: string | null;
  isOutcoming: boolean;
};

export const ImageAsDocumentMessage: React.FC<TImageAsDocumentMessageProps> = ({
  imageNode,
  name,
  size,
  src,
  isOutcoming,
}) => {
  return (
    <div className={styles['container']} data-name="ImageAsDocumentMessage">
      <div className={styles['content']} data-name="ImageAsDocumentMessage_image">
        {imageNode}
      </div>
      <div className={styles['info']}>
        <span className={styles['name']} data-name="ImageAsDocumentMessage_name">
          {src ? (
            <a href={src} download>
              <UIText1 color={isOutcoming ? 'white_100' : 'primary_100'}>{name} </UIText1>
            </a>
          ) : (
            <UIText1 color={isOutcoming ? 'white_100' : 'primary_100'}>{name} </UIText1>
          )}
        </span>
        <UIText3 color={isOutcoming ? 'white_100' : 'gray60_100'} data-name="ImageAsDocumentMessage_size">
          Файл{size && ` • ${size}`}
        </UIText3>
      </div>
    </div>
  );
};
